import { ActionTypes } from './actionTypes'

export interface IfetchAllContent {
  type: ActionTypes.fetchAllContent
}

export interface IfetchAllContentResolved {
  type: ActionTypes.fetchAllContentResolved
  content: any
}

export interface IfetchAllContentRejected {
  type: ActionTypes.fetchAllContentRejected
  error: boolean
  payload: any
}

export const fetchAllContent = (): IfetchAllContent => ({
  type: ActionTypes.fetchAllContent,
})

export const fetchAllContentResolved = (
  content: any,
): IfetchAllContentResolved => ({
  content,
  type: ActionTypes.fetchAllContentResolved,
})

export const fetchAllContentRejected = (
  payload: any,
): IfetchAllContentRejected => ({
  error: true,
  payload,
  type: ActionTypes.fetchAllContentRejected,
})

export type fetchAllContentAction = () => IfetchAllContent



// WEBPACK FOOTER //
// ./src/actions/index.ts